import { createContext } from 'react';
import type { UserProfile } from './session';

export interface AuthContextValue {
  user: UserProfile | null;
  isAuthenticated: boolean;
  /** True until the initial refresh probe finishes. */
  isLoading: boolean;
  setSession: (user: UserProfile, accessToken: string) => void;
  updateUser: (user: UserProfile) => void;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
